import axios from 'axios';

const getResult = async (params = {}) => {
    const response = await axios
        .get("result", {params: {...params}});
    return response.data.data;
};


export {getResult};
